import ThaiAddressData from '@/resources/mixins/ThaiAddressData';

export default  {
    mixins: [ThaiAddressData],
    data() {
        return {
            mixinsThaiAddress_DataIndex: { 
                tumbon: 0,
                amphur: 1,
                province: 2,
                postcode: 3
            },
            mixinsThaiAddress_List: [],
            mixinsThaiAddress_Separator: ' » '
        } 
    },
    methods: {
        mixinsThaiAddress_SetAutoComplete(typing, selector) {
            this.mixinsThaiAddress_List = this.mixinsThaiAddress_GetAutoCompleteAddress(typing, selector);
        },
        mixinsThaiAddress_GetAutoCompleteAddress(typing, selector) {
            var items = [];

            this.jsonAddress.forEach((valueProvince) => {
                if (selector != 'province' || valueProvince.province.indexOf(typing) === 0) {
                    valueProvince.listAmphur.forEach((valueAmphur) => {
                        if (selector != 'amphur' || valueAmphur.amphur.indexOf(typing) === 0) {
                            valueAmphur.listTumbon.forEach((valueTumbon) => {
                                if ((selector != 'tumbon' || valueTumbon.tumbon.indexOf(typing) === 0) && (selector != 'postcode' || valueTumbon.postcode.indexOf(typing) === 0)) {
                                    items.push(valueTumbon.tumbon + this.mixinsThaiAddress_Separator + valueAmphur.amphur + this.mixinsThaiAddress_Separator + valueProvince.province + this.mixinsThaiAddress_Separator + valueTumbon.postcode);
                                }
                            });
                        }
                    });
                }
            });
    
            return items;
        },
        mixinsThaiAddress_SetThaiAddressValue(value) {
            var selected = value.split(this.mixinsThaiAddress_Separator);

            this.$refs.thaiAddressDataTumbon.inputValue = selected[this.mixinsThaiAddress_DataIndex.tumbon];
            this.$refs.thaiAddressDataAmphur.inputValue = selected[this.mixinsThaiAddress_DataIndex.amphur];
            this.$refs.thaiAddressDataProvince.inputValue = selected[this.mixinsThaiAddress_DataIndex.province];
            this.$refs.thaiAddressDataPostCode.inputValue = selected[this.mixinsThaiAddress_DataIndex.postcode];
        },
        mixinsThaiAddress_CheckValidInputAddress(e, selector) {
            var target = e.relatedTarget;

            if ((!target || (target && !target.classList.contains('autocomplete-item'))) && this.mixinsThaiAddress_List.filter(x => x.split(this.mixinsThaiAddress_Separator)[this.mixinsThaiAddress_DataIndex[selector]] == e.target.value).length == 0) {
                this.$refs.thaiAddressDataTumbon.inputValue = '';
                this.$refs.thaiAddressDataAmphur.inputValue = '';
                this.$refs.thaiAddressDataProvince.inputValue = '';
                this.$refs.thaiAddressDataPostCode.inputValue = '';
            }
        }
    }
}